import styled from 'styled-components';
import React, { useState, useEffect } from 'react';

const MoleculeFullScreenButton = ({ style }) => {
    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        const handleFullScreenChange = () => {
            setIsFullScreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullScreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullScreenChange);
        };
    }, []);

    const handleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch(err => {
                console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
            });
        } else {
            document.exitFullscreen();
        }
    }
    return (
        <FullScreenButton type="button" onClick={handleFullScreen} style={style}>
            <FullScreenSVG viewBox="0 0 24 24">
                {isFullScreen ? (
                    <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
                ) : (
                    <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
                )}
            </FullScreenSVG>
        </FullScreenButton>
    )
}

export default MoleculeFullScreenButton;

const FullScreenButton = styled.button`
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    background: #ecf2fe;
    border: none;
    cursor: pointer;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;

    &:hover {
        background: #c2cce6;
    }
`;
const FullScreenSVG = styled.svg`
    width: 48px;
    height: 48px;
    fill: #333;
`;
